import * as types from './types';
import fetchData from '../../../shared/helpers/fetchData';
import fetchOptions from '../../../shared/helpers/fetchOptions';


export const receiveSuggestion = search => ({
  type: types.RECEIVE_AUTO_SUGGESTIONS,
  search,
});

export const getAutoSuggestion = function autoSuggestion(autoSuggestUrl, query) {
  return function doCartAction(dispatch) {
    const url = `${autoSuggestUrl}${encodeURIComponent(query)}`;
    const options = fetchOptions();
    const handlers = {
      successHandler: receiveSuggestion,
      dispatch,
    };

    return fetchData(url, options, handlers);
  };
};

export const resetIneligibleAddOns = function resetIneligibleAddOns(resetIneligibleUrl) {
  return function doResetAction(dispatch) {
    const url = resetIneligibleUrl;
    const options = fetchOptions();
    const handlers = {
      successHandler: () => {},
      dispatch,
    };

    return fetchData(url, options, handlers);
  };
};
